var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.$t("billingPage.totalBalance")) + " ："
                  ),
                  _c("a", { staticStyle: { color: "cadetblue" } }, [
                    _vm._v("$" + _vm._s(_vm.extendData ? _vm.extendData : 0)),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.showBtn,
                        type: "primary",
                        plain: "",
                      },
                      on: { click: _vm.onExportBill },
                    },
                    [_vm._v(_vm._s(_vm.$t("billingPage.Download")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("billingPage.BillingServiceInvoices")) + " ")]
      ),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
        },
        on: {
          afterFetchOriginalData: _vm.getListData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.searchIDs"),
                          prop: "invoiceId",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("billingPage.searchID"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.invoiceId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "invoiceId", $$v)
                            },
                            expression: "queryParams.invoiceId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.yearAndWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "getWeekDate",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Status"),
                          prop: "state",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list": _vm.BILLING_PAGE_STATUS,
                          },
                          model: {
                            value: _vm.queryParams.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "state", $$v)
                            },
                            expression: "queryParams.state",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: _vm.colSpan } }, [
                  _c("div", { staticStyle: { width: "30px", height: "10px" } }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "invoiceNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#3173d0" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "state"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.BILLING_PAGE_STATUS.bjGet(
                                                    scope.row.state
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onInvoice(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "billingPage.downloadInvoice"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onReport(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("billingPage.downloadReport")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }